import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome,
  FiFileText,
  FiSettings,
  FiShield,
  FiX,
  FiUser,
} from "react-icons/fi";
import { GiBookmark } from "react-icons/gi";


import SimpleBar from "simplebar-react";
import { actions, getToken, hasPermission } from "./../../services/security";

import { Button } from "antd";
import { useSide } from "../../store/sidebar-context";
import { BASEURL } from "../../services/url";
import classes from "./sidebar.module.scss";

import logo1 from "../../assets/images/logo_Banco_Entre_Rios.svg";
import logo2 from "../../assets/images/logo_Banco_San_Juan.svg";
import logo3 from "../../assets/images/logo_Banco_Santa_Cruz.svg";
import logo4 from "../../assets/images/logo_Banco_Santa_Fe.svg";
import logo5 from "../../assets/images/logoSoluciones.png"
import http from "../../services/http";


const Sidebar = () => {
  let { sideBarVisible, setSideBarVisible } = useSide();
  const [logo, setLogo] = useState();
  const [sections, setSections] = useState([
    {
      title: "",
      links: [
        {
          title: "Inicio",
          url: "/",
          icon: <FiHome />,
          visible: true,
        },
        {
          title: "Plantillas",
          url: "/Plantillas",
          icon: <FiFileText />,
          visible: hasPermission(actions.PlantillaMasterDocVer),
        },
        {
          title: "Diccionario",
          url: "/Diccionario",
          icon: <GiBookmark />,
          visible: hasPermission(actions.DiccionarioVer),
        }
      ],
    },
    {
      title: "Seguridad",
      links: [
        {
          title: "Perfiles",
          url: "/perfiles",
          icon: <FiShield />,
          visible: hasPermission(actions.PerfilesVer),
        },
        {
          title: "Usuarios",
          url: "/usuarios",
          icon: <FiUser />,
          visible: hasPermission(actions.UsuariosVer),
        },
      ],
    },
  ]);
  const open = () => {
    setSideBarVisible(!sideBarVisible);
  };

  useEffect(() => {
    async function getLogo() {
      const response = await http.get(`${BASEURL}/Parametry/Nombre/BANCO`);
      const data = response.data.valor;
      localStorage.setItem("banco", data);
      switch (data) {
        case "BER":
          setLogo(logo1);
          break;
        case "BSJ":
          setLogo(logo2);
          break;
        case "BSC":
          setLogo(logo3);
          break;
        case "BSF":
          setLogo(logo4);
          break;
        default:
          setLogo(logo5);
      }
    }
    getLogo()
  }, []);

  return (
    sideBarVisible && (
      <div className={classes.sidebar}>
        <div className={classes.brand}>
          <img className={classes.logo} src={logo} alt="logo" />
          <Button
            type="text"
            shape="circle"
            size="large"
            onClick={() => {
              open();
            }}
          >
            <FiX />
          </Button>
        </div>

        <SimpleBar style={{ maxHeight: "calc(100vh - 65px)" }}>
          <div className={classes.sections}>
            {sections.map(
              (s, index) =>
                s.links.filter((x) => x.visible).length > 0 && (
                  <div key={index} className={classes.section}>
                    <div className={classes.title}>{s.title}</div>
                    {s.links.map(
                      (i, lIndex) =>
                        i.visible && (
                          <NavLink
                            key={lIndex}
                            className={({ isActive }) =>
                              isActive
                                ? `${classes.link} ${classes.active}`
                                : `${classes.link}`
                            }
                            to={i.url}
                          >
                            <div className={classes.icon}>{i.icon}</div>
                            <div className={classes.title}>{i.title}</div>
                          </NavLink>
                        )
                    )}
                  </div>
                )
            )}
          </div>
        </SimpleBar>
      </div>
    )
  );
};

export default Sidebar;
